export default function TerraformHome() {
  return <div style={{ color: "#FFF" }}>DashBoard?</div>;
}
